import { render, staticRenderFns } from "./assist.vue?vue&type=template&id=2675ee3a&scoped=true"
import script from "./assist.vue?vue&type=script&lang=js"
export * from "./assist.vue?vue&type=script&lang=js"
import style0 from "./assist.vue?vue&type=style&index=0&id=2675ee3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2675ee3a",
  null
  
)

export default component.exports